export enum BOOK_TYPE {
  LIBRARY = 'LIBRARY',
  LIBRARY3 = 'LIBRARY3',
  BIBLIOTECA = 'BIBLIOTECA',
  CAMINOS_BIBLIOTECA = 'CAMINOS',
  TEXAS_ELAR = 'TEXAS_ELAR',
  TEXAS_SLAR = 'TEXAS_SLAR',
}

export enum ebookKeys {
  LIBRARY = 'library',
  LIBRARY3 = 'library',
  BIBLIOTECA = 'biblioteca',
  CAMINOS = 'caminos',
  TEXAS_ELAR = 'texaselar',
  TEXAS_SLAR = 'texasslar',
}

export const EBOOK_META_CHAPTERS = [
  'cover',
  'front cover',
  'table of contents',
  'tables of contents',
  'title page',
  'tapa',
  'title',
  'portada',
  'contenido',
  'contents',
]

export const EBOOK_TOC_PART_REG = /^(parte|part)\s\w{1,5}\s?$/i

export const EBOOK_TOC_CHAPTERS = {
  INTRO: ['introduction', 'introducción', 'introducción'],
  CHAPTER: ['chapter', 'capítulo', 'capítulo'],
}

export const READERS_TABS = {
  SKILLS_2021: 'Updated Skills Readers',
  SKILLS_2020: 'Skills Readers',
}

export const ZOOM_STEP_AMOUNT = 0.25
export const MAX_ZOOM_LEVEL = 2
export const MIN_ZOOM_LEVEL = 1
export const ZOOM_TRANSLATE_LEFT_PER_STEP = 330
export const ZOOM_TRANSLATE_TOP_PER_STEP = 320
